import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function GetBrandProfileListService(token,data) {
    console.log("first")
    console.log(token)

    return axios.post(`${CURRENT_API_URL}/questionnaire/getBrandProfileList`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
            return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching brand profile list. please try again later.");
        return false;
    });
}


export default GetBrandProfileListService;
